import script from "./SponsorsView.vue?vue&type=script&setup=true&lang=js"
export * from "./SponsorsView.vue?vue&type=script&setup=true&lang=js"

import "./SponsorsView.vue?vue&type=style&index=0&id=129666b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-129666b8"]])

export default __exports__